// extracted by mini-css-extract-plugin
module.exports = {"cardImageContainer":"card-image_cardImageContainer___bOeO","cardImageContainerCenter":"card-image_cardImageContainerCenter__hTre_","caption":"card-image_caption__1xEXF"};